import { render, staticRenderFns } from "./Printer.vue?vue&type=template&id=13923a9a&scoped=true"
import script from "./Printer.vue?vue&type=script&lang=js"
export * from "./Printer.vue?vue&type=script&lang=js"
import style0 from "./Printer.vue?vue&type=style&index=0&id=13923a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13923a9a",
  null
  
)

export default component.exports